'use strict';

function loadScript(url, callback) {
    var head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
    var script = document.createElement('script');

    script.async = 'async';
    script.src = url;

    script.onload = script.onreadystatechange = function (_, abort) {
        if (abort || !script.readyState || (/loaded|complete/).test(script.readyState)) {
            script.onload = script.onreadystatechange = null;

            if (head && script.parentNode) {
                head.removeChild(script);
            }

            script = undefined;

            if (!abort) {
                callback();
            }
        }
    };

    head.insertBefore(script, head.firstChild);
}

module.exports = loadScript;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/script-loader.js
 ** module id = 30
 ** module chunks = 0
 **/